import { Marker } from "@googlemaps/markerclusterer";
import { InfoWindow } from "@vis.gl/react-google-maps";
import { convertTimestampToDaysAgo } from "../../helpers/util";
import { ReactComponent as Heart } from "../../assets/svg/heart.svg";
import { Link } from "react-router-dom";

interface IProps {
  anchor: Marker;
  handleInfoWindowClose: () => void;
  selected: any;
  isFavorited: boolean;
  toggleFavorite: () => Promise<void>;
  isCommercial: boolean;
}

export const Infowindow = ({
  anchor,
  handleInfoWindowClose,
  selected,
  isFavorited,
  toggleFavorite,
  isCommercial,
}: IProps) => {
  return (
    <InfoWindow
      anchor={anchor}
      onCloseClick={handleInfoWindowClose}
      headerDisabled
      className="w-full"
    >
      <div>
        <Link
          to={
            isCommercial
              ? `/commercial/${selected.listing_unique_id}`
              : `/${selected.listing_unique_id}`
          }
        >
          <img
            alt={selected.name}
            width={"100%"}
            src={
              "https://maps.googleapis.com/maps/api/streetview?size=356x200&location=" +
              selected.latitude +
              "," +
              selected.longitude +
              "&key=AIzaSyCclBCu30QD5vsNQKwg8PKrn2EofxY6YP4&source=outdoor"
            }
          />
        </Link>

        <div className="absolute flex justify-between w-[86%] top-6 pl-2">
          <div>
            <span
              style={{ paddingTop: "2px", paddingBottom: "2px" }}
              className="px-2 border border-blue-200 bg-blue-50 text-blue-700 h-fit"
            >
              {convertTimestampToDaysAgo(selected.time_listed)}
            </span>
          </div>

          <button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              toggleFavorite();
            }}
            className={`p-3 ${
              isFavorited ? "bg-rose-600" : "bg-white bg-opacity-50"
            } border border-white border-opacity-60 text-white`}
          >
            <Heart />
          </button>
        </div>
      </div>

      <h5 className="text-[#2970FF] text-sm font-semibold mt-5">
        <Link
          to={
            isCommercial
              ? `/commercial/${selected.listing_unique_id}`
              : `/${selected.listing_unique_id}`
          }
        >
          {selected.name}
        </Link>
      </h5>
    </InfoWindow>
  );
};
